/*Recurso Analysis: objetivo guardar la lectura del api
  Tareas:
     Analysis/GetSummarybyUser/es
     Analysis/GetDetailbyUser/es
     Analysis/UpdatebyUser/es
     Analysis/SendbyUser/ 
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const analysisStore = create((set:any, get:any) => ({

  objErrorAnalysisStore: { hasError: false, url: '', body:'',  recurso:'', componente:'analysis', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error

      //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI  
        limpiaObjErrorAnalysisStore: () => {
          //alert('Analysis.store - limpiaObjErrorAnalysisStore:');
          let paso = { hasError: false, url:'', body:'', recurso:'', componente:'analysis', idresul:0, desresul:'', menu:''}
          set( { objErrorAnalysisStore: paso } );
          //console.log('limpiaObjErrorAnalysisStore (sale) - objErrorAnalysisStore: ', get().objErrorAnalysisStore);
        },
                  
      //*Error en api: entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
        generaObjErrorAnalysisStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
          //console.clear();
          //console.log('*generaObjErrorAnalysisStore (entra): ', responseAPI);
          //console.log('*generaObjErrorAnalysisStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
          let paso = { hasError: h, url:'', body:e, recurso:'analysis', componente:c, idresul:0, desresul:'', menu:m };
          if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
              paso.idresul=-1;
              paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
          }
          else if (responseAPI=='Error detectado por api en ret') {
            paso.desresul= h;
            paso.idresul= h2; 
          }
          else {
            let temp = responseAPI.config;
            paso.url = temp.url;
            if (responseAPI.data!='' && responseAPI.data!=null){
              console.log('paso2');
                paso.idresul=responseAPI.data.ret;
                paso.desresul= responseAPI.data.msjerror;
            }    
            else {
                paso.idresul= responseAPI.status;
                switch(responseAPI.status){
                  //case 404:  paso.desresul= "El usuario no existe"; break;
                  case 401:  paso.desresul= "No autorizado"; break;
                  case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
                  default: paso.desresul= responseAPI.statusText; break;
                }
            }    
          }
          //console.log('paso', paso);
          set( { objErrorAnalysisStore: paso } );
          console.log('::AnalysisStore - generaObjErrorAnalysisStore (sale) - objErrorAnalysisStore: ', get().objErrorAnalysisStore);
        },

  pfcStore:[],  //**Unidad de medida: Proceso/Frecuencia/Ciclo
    
      //*Tareas: GetSummarybyUser: recibe el response.data y lo guarda en pfcStore
      guardaGetSummarybyUserStore: async (responseAPI:any, catPtCiclos:any) => { 
        //console.clear();
        //console.log('guardaGetSummarybyUserStore - responseAPI:', responseAPI)

        var _ = require('underscore');
        if (responseAPI.ret==1) { //sin error
          
          //se hace un filtro para mostrar solo las no enviadas
          let pfcPaso = _.filter(responseAPI.item, function(fil:any) { return fil.sent==false });

          set ( { pfcStore: pfcPaso } );  

          if (get().pfcStore!= null) {
              get().pfcStore.map((pfc:any, indexPFC:any) => {
                  pfc.abierto = false; //por omisión entra cerrado
                  pfc.pfcNombre = pfc.acronym + ' / ' + pfc.frequencyname + ' / ' + pfc.cyclename;
                  pfc.estatusTexto = (pfc.sent) ? "Enviada" : "En proceso";
                  pfc.totalPropuestas = pfc.nproposals;

                  //para generar el efecto del activo/no activo...
                    let paso = pfc.state_process;
                    pfc.estatusProceso = paso.pt_state_description;
                    pfc.clasexEstatusIcono = '';
                    switch ( paso.pt_state ) {
                      case 1: pfc.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                      case 2: pfc.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                      case 3: pfc.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                      case 4: pfc.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                      default: pfc.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
                    }
                    //pfc.Detalles = {};
              });
          }
          console.log (':::pfcStore: ', get().pfcStore );
          return(get().pfcStore);
        }
        else {
          get().generaObjErrorAnalysisStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'analysis.store-guardaGetSummarybyUserStore')
        }
      },

      cambiaPFCStore: async ( idpfc:any, abierto:any, detalle:any, dondeViene:any ) => { 
        //alert('cambiaPFCStore - index: ' + index + '  abierto: ' + abierto + ' detalle: '+ detalle + ' dondeViene: ' + dondeViene)
        //console.log('**cambiaPFCStore - idpfc: ', idpfc , ' dondeViene: ', dondeViene);
        switch (dondeViene){
          case 'guardaGetDetailbyUserStore':  
                get().pfcStore.map((pfc:any, indexPFC:any) => {
                  if (pfc.id==idpfc) { pfc.abierto = true }
                  else { pfc.abierto = false }
                }); 
          break;
        }
      },
    
  pfcDetallesStore: {},  //PFC detalles al dar clic en botón Documentar
  pfcDetalleVacia: {
      id: 0, processname: "", acronym: "", frequencyname: "", cyclename: "",  sent: true, nproposals: 0, decision: [],
      state_process: {  pt_state: 0, pt_state_description: "", onwaiting: true, leftdays: 0 },
      state_cycle: { pt_state: 0, pt_state_description: "", onwaiting: true },
      pt_md: [ { name: "", description: "", value: "" } ],
      proposal: [ { id: 0, folio: "" } ],
      files: [ { id: 0, classified: "", path: "", name: "", originalfullname: "", createdAt: "" } ],
      evidence: [ { id: 0, name: "", feature: [ { id: 0, name: "" } ], proof: [ {id: 0,  name: "", allowtext: true,  other: "" } ] } ],
      misArchivos:[]
  },
  pfcMisArchivosVacia: [
    { idTipo:'NR',      activo:true,  descripcion:'Revisión de necesidades ', art:10 , archivos: [] },
    { idTipo:'CR',      activo:true,  descripcion:'Relación de cambios ', art:12, archivos: [] },
    { idTipo:'PROOF',   activo:false, descripcion:'Reporte de resultados de las pruebas ', art:14, archivos: [] },
    { idTipo:'JUSTIFY', activo:false, descripcion:'Justificación de no realizar pruebas ', art:14, archivos: [] },
    { idTipo:'API',     activo:true,  descripcion:'Plan de acción ', art:15, archivos: [] },
  ],

  nrArchivosStore: [], 
  crArchivosStore: [], 
  proofArchivosStore: [], 
  justifyArchivosStore: [], 
  apiArchivosStore: [], 

      //*Tareas: GetDetailbyUser  // response.data, idpfc, catD (Decision), catP (Pruebas), catEC(Evidencias-Caracteriticas), este trae las caracteristicas por cada evidencia
      guardaGetDetailbyUserStore: async (responseAPI:any, idpfc:any, catD:any, catP:any, catEC:any) => { 
        //console.clear()
        //console.log('responseAPI', responseAPI);
        //console.log('idpfc:', idpfc, '  catD:', catD, ' catP: ',  catP, ' catEC:', catEC)
        var _ = require('underscore');
        
        set ( { pfcDetallesStore: get().pfcDetalleVacia } );
        set ( { pfcDetallesStore: responseAPI.item } );
        let nrPaso:any = [];
        let crPaso:any = [];
        let proofPaso:any = [];
        let justifyPaso:any = [];
        let apiPaso:any = [];
        let activaBtnEnviar = true; //aquí vamos captando si esta completa la plantila para activar el botón enviar desde que abre

        if (responseAPI.ret==1) { //sin error

            //*Archivos, agregamos sus elementos a misArchivos
              get().pfcDetallesStore.misArchivos = [];
              get().pfcDetallesStore.misArchivos = [
                { idTipo:'NR',      activo:true,  descripcion:'Revisión de necesidades ', art:10 , archivos: [] },
                { idTipo:'CR',      activo:true,  descripcion:'Relación de cambios ', art:12, archivos: [] },
                { idTipo:'PROOF',   activo:false, descripcion:'Reporte de resultados de las pruebas ', art:14, archivos: [] },
                { idTipo:'JUSTIFY', activo:false, descripcion:'Justificación de no realizar pruebas ', art:14, archivos: [] },
                { idTipo:'API',     activo:true,  descripcion:'Plan de acción', art:15, archivos: [] },
              ]; //generamos un arreglo store por cada elemento de archivo (5 en total) para el manejo interno del dropzone

              let rutaNAS = process.env.REACT_APP_SERV_HOSTNAME + 'docs/analysis/'; //ruta en donde quedarán los archivos

              //archivos
                nrPaso = [];
                crPaso = [];
                proofPaso = [];
                justifyPaso = [];
                apiPaso = [];
                if (get().pfcDetallesStore.files != null && get().pfcDetallesStore.files.length > 0 ) {
                    get().pfcDetallesStore.files.map((f:any, indexF:any) => {
                          f.descarga  = rutaNAS + f.path + '/' + f.originalfullname;
                          f.action = 0;
                          //console.log (':::f.classified: ', f.classified );
                          switch (f.classified ) {
                            case 'NR':      nrPaso.push(f);      get().pfcDetallesStore.misArchivos[0].archivos.push(f); break;
                            case 'CR':      crPaso.push(f);      get().pfcDetallesStore.misArchivos[1].archivos.push(f); break;
                            case 'PROOF':   proofPaso.push(f);   get().pfcDetallesStore.misArchivos[2].archivos.push(f); get().pfcDetallesStore.misArchivos[2].archivos.activo=true; break;
                            case 'JUSTIFY': justifyPaso.push(f); get().pfcDetallesStore.misArchivos[3].archivos.push(f); get().pfcDetallesStore.misArchivos[3].archivos.activo=true; break;
                            case 'API':     apiPaso.push(f);     get().pfcDetallesStore.misArchivos[4].archivos.push(f); break;
                          }
                    });
                    // si alguno de los elementos no tiene archivos no podemos dejar que se active el botón enviar
                    get().pfcDetallesStore.misArchivos.map((ma:any, indexMa:any) => {
                        if (ma.archivos.length==0 && ma.activo) { activaBtnEnviar = false }
                    })  
                }
                else { activaBtnEnviar = false };
                set ( { nrArchivosStore: nrPaso } );
                set ( { crArchivosStore: crPaso } );
                set ( { proofArchivosStore: proofPaso } );
                set ( { justifyArchivosStore: justifyPaso } );
                set ( { apiArchivosStore: apiPaso } );
              //

            //*CatD - Decisiones, se extraen decision de pfc y se consulta catálgo decisiones para saber sus nombres, usado en la ventana en encabezado  
              let pasoD = get().pfcDetallesStore.decision.filter((item:any,index:any)=>{
                  return get().pfcDetallesStore.decision.indexOf(item) === index;
              })
              if (pasoD.length>0){
                get().pfcDetallesStore.decisionTexto = [];
                pasoD.map((pD:any, indexpD:any) => {
                    catD.map((d:any, indexCatD:any) => { if (pD == d.id) { get().pfcDetallesStore.decisionTexto.push(d.name) } });
                });
              }   
              else { get().pfcDetallesStore.decisionTexto = null }  

              get().pfcDetallesStore.decisionTextoTodos = [];//botón documentar- liga folio de propuesta, se presenta el estatus
              get().pfcDetallesStore.decision.map((d:any, indexD:any) => {
                  if (d == 2) { get().pfcDetallesStore.decisionTextoTodos.push('Prevista') }
                  if (d == 3) { get().pfcDetallesStore.decisionTextoTodos.push('No Prevista') }
              });  

            //*Evidencias a cada una le agregamos el catPruebas y catECaractericas con los valores leídos del api  
              let pasoEV = get().pfcDetallesStore.evidence;
              pasoEV.map((ev:any,  indexEV:any) => {
                  ev.abierto = false;
                  ev.swEviCatCaracteristicas = true;
                  ev.swEviCatPruebas = true;
                  ev.swEviCatPruebasOtro = true;
             
                  //CatP - Pruebas
                  //let copiaCatP = catP;
                  let copiaCatP= JSON.parse(JSON.stringify(catP));
                  if (ev.proof.length > 0) { //trae información desde api vaciamos al catálogo
                      let pasoCatP:any = [];
                      pasoCatP = _.pluck(ev.proof, 'id');
                      //console.log('ev.id', ev.id, '......pasoCatP: ',pasoCatP);
                      copiaCatP.map((catP:any, indexCopiaCatP:any) => {
                          catP.otraTexto = ''; 
                          pasoCatP.map((pp:any, indexPasoCatP:any) => {  
                            if (catP.id == pp) { 
                                catP.activo = true;
                                //ev.swEviCatPruebas = true;
                                if (catP.name == 'Otra') {
                                    catP.otraTexto = ev.proof[indexPasoCatP].other;
                                    if (ev.proof[indexPasoCatP].other == null || ev.proof[indexPasoCatP].other == '' ) {
                                        ev.swEviCatPruebasOtro = false;
                                        activaBtnEnviar = false;
                                    }    
                                }
                            };
                            if (catP.name != 'Ninguno' && catP.activo ) { 
                              get().pfcDetallesStore.misArchivos[2].activo = true;
                              if (pasoEV.length==1) { get().pfcDetallesStore.misArchivos[3].activo = false} //si es una solo evidencia es excluyente
                            };
                            if (catP.name == 'Ninguno' && catP.activo ) { 
                                get().pfcDetallesStore.misArchivos[3].activo = true;
                                if (pasoEV.length==1) { get().pfcDetallesStore.misArchivos[2].activo = false}//si es una solo evidencia es excluyente
                                if (get().pfcDetallesStore.misArchivos[3].archivos.length == 0) { activaBtnEnviar = false }
                            } ;
                          });
                      });  
                  }
                  else {
                      ev.swEviCatPruebas = false;
                      ev.swEviCatPruebasOtro = false;
                      activaBtnEnviar = false;
                  }
                  ev.miCatPruebas = copiaCatP;

                //CatC - Caracteristicas
                  //let copiaCatEC = catEC;
                  let copiaCatEC= JSON.parse(JSON.stringify(catEC));
                  let catPasoC:any = [];
                  if (ev.feature.length > 0) { //trae información desde api vaciamos al catálogo
                    let idActivas:any = [];
                    idActivas = _.pluck(ev.feature, 'id');
                    //console.log (':::::::::pasoCatC: ', pasoCatC );
                    copiaCatEC.map((catEC:any, indexcatEC:any) => {
                        if (ev.id == catEC.id) {
                            catPasoC = [];
                            catEC.features.map((catEC_C:any, indexCatEC_C:any) => {
                                catEC_C.activo = false; 
                                idActivas.map((idAct:any, indexIdAct:any) => { 
                                    if (catEC_C.id==idAct) {  catEC_C.activo = true }   
                                });
                            });
                            catPasoC = catEC.features; 
                        }  
                    });
                  }
                  else {
                      ev.swEviCatCaracteristicas = false;
                      activaBtnEnviar = false;
                      copiaCatEC.map((catEC:any, indexcatEC:any) => {
                        if (ev.id == catEC.id) {
                            catPasoC = [];
                            catEC.features.map((catEC_C:any, indexCatEC_C:any) => { catEC_C.activo = false });
                            catPasoC = catEC.features; 
                        }  
                      });
                      //catPasoC = catEC.features; 
                  }
                  ev.miCatCaracteristicas = catPasoC;

              });  
              get().pfcDetallesStore.evidence = pasoEV;

            //*Generales para manejo del front  
              get().pfcDetallesStore.abierto = true;
              get().pfcDetallesStore.btnGuardar = get().pfcDetallesStore.sent ? null : false;
              get().pfcDetallesStore.btnEnviar =  get().pfcDetallesStore.sent ? null : activaBtnEnviar;

              get().pfcDetallesStore.totalDecision = _.uniq(get().pfcDetallesStore.decision);

              //para ver etiqueta de activo en la ventana sp
              let pasoSP = get().pfcDetallesStore.state_process;
              get().pfcDetallesStore.estatusProceso = pasoSP.pt_state_description;
              if (get().pfcDetallesStore.totalDecision==3){ //No previsto 
                  get().pfcDetallesStore.misArchivos[4].descripcion = 'Informe de instrumentación';
                  get().pfcDetallesStore.misArchivos[4].art = 24;
              }


              get().pfcDetallesStore.clasexEstatusIcono = "";
              switch ( pasoSP.pt_state ) {
                case 1:  get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                case 2:  get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                case 3:  get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                case 4:  get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                default: get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
              }

            //*resultado del api & elementos para manejo del front
              console.log (':::::::pfcDetallesStore: ', get().pfcDetallesStore );
              //console.log (':::nrArchivosStore: ', get().nrArchivosStore );
              //console.log (':::crArchivosStore: ', get().crArchivosStore );
              //console.log (':::proofArchivosStore: ', get().proofArchivosStore );
              //console.log (':::justifyArchivosStore: ', get().justifyArchivosStore );
              //console.log (':::apiArchivosStore: ', get().apiArchivosStore );

            //mandamos la lectura a pfcStore
              // get().cambiaPFCStore( idpfc, true, get().pfcDetallesStore, 'guardaGetDetailbyUserStore');
              get().cambiaPFCStore( idpfc, true, null, 'guardaGetDetailbyUserStore');
               //console.log (':::pfcStore: ', get().pfcStore );

          return(get().pfcDetallesStore);
        }
        else {
             get().generaObjErrorAnalysisStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'analysis.store-guardaGetDetailbyUserStore')
        }
      }, 

      cambiaPFCDetalleStore: async ( idpfc:any, idEvi:any, detalle:any, swActiva: any, dondeViene:any ) => { 
        //alert('cambiaPFCDetalleStore - index: ' + index + '  abierto: ' + abierto + ' detalle: '+ detalle + ' dondeViene: ' + dondeViene)
        //console.log('**cambiaPFCDetalleStore - idpfc: ', idpfc , ' dondeViene: ', dondeViene);
        switch (dondeViene){
          case 'guardaGetDetailbyUserStore':  
                get().pfcStore.map((pfc:any, indexPFC:any) => {
                  if (pfc.id==idpfc)  
                      pfc.abierto = true;
                  else  
                      pfc.abierto = false;
                }); 
          break;
          case 'botonEnviar':  
                get().pfcStore.map((pfc:any, indexPFC:any) => {
                  if (pfc.id==idpfc) {
                      pfc.abierto = false;
                      pfc.sent = true;
                  }    
                }); 
                get().pfcDetallesStore.btnGuardar = null;
                get().pfcDetallesStore.btnEnviar= null;
                get().pfcDetallesStore.send = true;
                //get().pfcDetallesStore.abierto = false;
          break;
          case 'cambiaCheckCaracteristicas':  
                get().pfcDetallesStore.evidence.map((pfcEvi:any, indexPfcEvi:any) => {
                  if (pfcEvi.id == idEvi) { 
                      pfcEvi.miCatCaracteristicas = detalle;
                      pfcEvi.swEviCatCaracteristicas = swActiva;
                      // si el sw es false entonces deactivamos el botonEnviar 
                      if (pfcEvi.swEviCatCaracteristicas == false) { get().pfcDetallesStore.btnEnviar = false }
                  }      
                }); 
          break;
          case 'cambiaCheckPruebas': 
                let swCatSel = false;
                get().pfcDetallesStore.evidence.map((pfcEvi:any, indexPfcEvi:any) => {
                    if (pfcEvi.id == idEvi) { 
                        pfcEvi.miCatPruebas = detalle;
                        pfcEvi.swEviCatPruebas = swActiva;
                    }
                    if (swActiva == false) { get().pfcDetallesStore.btnEnviar = false }

                    if (pfcEvi.miCatPruebas[4].activo) { pfcEvi.swEviCatPruebasOtro = true }
                    else {pfcEvi.swEviCatPruebasOtro = false};
                    pfcEvi.miCatPruebas.map((catP:any, indexCatP:any) => {
                        if (catP.activo) { swCatSel = true }
                    });
                   /////pfcEvi.swEviCatPruebas = swCatSel
                });
                
                if (swCatSel==false) { get().pfcDetallesStore.misArchivos[2].activo = false } //desactivo la caja de Reporte de resultados de las pruebas porque no esta activo ningun elemento
                //console.log(' get().pfcDetallesStore.misArchivos: ',  get().pfcDetallesStore.misArchivos)  
                
                //ocupa esta doble vuelta para activar Reporte o Justificación de pruebas (porque puede haber mas de una evidencia)
                let swUnaEvidencia = false;
                if (get().pfcDetallesStore.evidence.length==1) { swUnaEvidencia = true };
                
                let swEviNinguno = false;
                let swEviOtrasPruebas = false;
                get().pfcDetallesStore.evidence.map((pfcEvi:any, indexPfcEvi:any) => {
                    pfcEvi.miCatPruebas?.map((cp:any, indexCatP:any) => {
                      if (cp.name != 'Ninguno' && cp.activo) { swEviOtrasPruebas=true }
                      if (cp.name == 'Ninguno' && cp.activo) { swEviNinguno=true }
                    });    
                });  
                if (swEviOtrasPruebas) {
                    get().pfcDetallesStore.misArchivos[2].activo = true;
                    if (swUnaEvidencia) { get().pfcDetallesStore.misArchivos[3].activo = false} //si es una sola evidencia es excluyente
                }  
                else { get().pfcDetallesStore.misArchivos[2].activo = false; }
                if (swEviNinguno) {
                    get().pfcDetallesStore.misArchivos[3].activo = true;
                    if (swUnaEvidencia) { get().pfcDetallesStore.misArchivos[2].activo = false} //si es una sola evidencia es excluyente
                }
                else { get().pfcDetallesStore.misArchivos[3].activo = false }  

                console.log ('::::::::::::::::pfcDetallesStore: ', get().pfcDetallesStore );
          break;  


          /* case 'cambiaTextoPruebasOtro':  
                get().pfcDetallesStore.evidence.map((pfcEvi:any, indexPFC:any) => {
                  if (pfcEvi.id == idEvi) { 
                      pfcEvi.miCatPruebas = detalle;
                      pfcEvi.swEviCatPruebasOtro = swActiva;
                      if (pfcEvi.swEviCatPruebasOtro == false) { get().pfcDetallesStore.btnEnviar = false }
                  }      
                });    
          break;  */
          case 'cambiaFilesNR':  
                get().pfcDetallesStore.misArchivos[0].archivos = detalle;
                get().nrArchivosStore = detalle;
          break;
          case 'cambiaFilesCR':  
                get().pfcDetallesStore.misArchivos[1].archivos = detalle;
                get().crArchivosStore = detalle;
          break;
          case 'cambiaFilesPROOF':  
                get().pfcDetallesStore.misArchivos[2].archivos = detalle;
                get().proofArchivosStore = detalle;
          break;
          case 'cambiaFilesJUSTIFY':  
                get().pfcDetallesStore.misArchivos[3].archivos = detalle;
                get().justifyArchivosStore = detalle;
          break;
          case 'cambiaFilesAPI':  
                get().pfcDetallesStore.misArchivos[4].archivos = detalle;
                get().apiArchivosStore = detalle;
          break; 
       
        } 
        //console.clear();
        //console.log ('::::::::::::::::pfcDetallesStore: ', get().pfcDetallesStore );
        // console.log ('::::::::::::::::pfcStore: ', get().pfcStore );
        //console.log('::::::::::::::::pfcDetallesStore', get().pfcDetallesStore)
      },

  updatebyUserStore:{},

      //*Tarea: UpdatebyUser
      //entra desde RD- botón:Guardar - 
      guardaUpdatebyUserStore: async (responseAPI:any) => {  
        //console.log('guardaUpdatebyUserStore-responseAPI:',responseAPI)
        if ( responseAPI.ret==1 ) { //inserto sin error
          set( { updatebyUserStore: responseAPI } );
          //console.log('updatebyUserStore:', get().updatebyUserStore);
          return(get().updatebyUserStore);
        }
        else {
          get().generaObjErrorAnalysisStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'analysis.store-guardaUpdatebyUserStore')
        }
      },

  sendbyUserStore:{},

      //*Tarea: SendbyUser
      //entra desde RP- botón: Registrar  - botón: Guardar - 
      guardaSendbyUserStore: async (responseAPI:any) => {  
        //console.log('guardaSendbyUserStore-responseAPI:',responseAPI)
        if ( responseAPI.ret==1 ) { //inserto sin error
          set( { sendbyUserStore: responseAPI } );
          //console.log('sendbyUserStore:', get().sendbyUserStore);
          return(get().sendbyUserStore);
        }
        else {
          get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'analysis.store-guardaSendbyUserStore')
        }
      },    
  
}));

export default analysisStore;
